import { render } from "./OrderPill.vue?vue&type=template&id=9e27f922"
import script from "./OrderPill.vue?vue&type=script&lang=ts"
export * from "./OrderPill.vue?vue&type=script&lang=ts"
script.render = render

export default script